import * as React from 'react'
import { styled } from 'next-yak'

import * as model from '@owl-nest/models'
import * as layout from '../layout'
import { Button, LinkAsButton, styles as S, VideoLoader } from '@ulule/owl-kit-components/next'
import { t, tc } from '@owl-nest/localize'

import * as projectModel from '../../../models/project'

const Coach = styled(layout.Coach)`
  ${VideoLoader} {
    margin: 14px 0;
  }
  ${Button} {
    width: 100%;
  }
`

type OffboardingFundedProps = {
  initialOpen: boolean
  project: projectModel.Project
  markStepSeen: () => Promise<void>
}

export function OffboardingFunded({
  initialOpen,
  project,
  markStepSeen,
}: OffboardingFundedProps): React.ReactElement<OffboardingFundedProps> | null {
  const manager = project.manager || project.default_manager

  const [open, setIsOpen] = React.useState(initialOpen)

  if (manager === undefined) {
    return null
  }

  const managerAvatar = model.image.getUrl(manager.avatar.versions, '128x128')

  return (
    <Coach closable={true} open={open} title={t('Clock is ticking ⏰')} onClose={handleDone} avatar={managerAvatar}>
      <S.copy.S.regular>
        {tc(
          `It’s almost over![br][br]Your campaign is ending but your project lives beyond Ulule, give your visitors the chance to continue to follow and support you! 👇`,
          { br: <br /> },
        )}
      </S.copy.S.regular>

      <Button onClick={goToOffboarding}>{t('Prepare your campaign')}</Button>

      <LinkAsButton kind="secondary" onClick={handleDone}>
        {t('Later')}
      </LinkAsButton>
    </Coach>
  )

  function handleDone(): void {
    setIsOpen(false)
    markStepSeen()
  }

  async function goToOffboarding(): Promise<void> {
    await markStepSeen()
    window.location.href = `/projects/${project.id}/backoffice/offboarding/`
  }
}
